export class AddedNewLeadEvent {}
